import { render, staticRenderFns } from "./CompaniesTab.vue?vue&type=template&id=0b2286ec"
import script from "./CompaniesTab.vue?vue&type=script&lang=js"
export * from "./CompaniesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports